<template>
  <div>
    <div v-for="(chat, chatIndex) in messages" :key="chatIndex">
      <div v-if="chat.messageType !== 'HOLD'">
        <div v-if="chat.messageType === 'START'" class="msgLine">
          <div class="box"><span class="chatIcon">상담사가 연결되었습니다.</span></div>
        </div>
        <div v-if="chat.messageType === 'CONNECT'" class="msgLine">
          <div class="box"><span class="chatIcon" v-html="parseTextFromContent(chat.content, chat.senderType)"></span></div>
        </div>
        <!-- UserMsg -->
        <div v-else-if="chat.senderType === 'USER'" class="userMsg">
          <div class="balloonBox">
            <div class="time">{{ printCreateMessageDateTime(chat.createDate) }}</div>
            <div class="msgBg" :style="{ backgroundColor: headerStyle.toolbarBackgroundColor }">
              <ImageList v-if="chat.messageType === 'PHOTO'" :content="chat.content"></ImageList>
              <video v-else-if="chat.messageType === 'VIDEO'" controls @click="videoClick(getVideoFromContent(chat.content))" class="VIDEO">
                <source :src="getVideoFromContent(chat.content)" />
              </video>
              <div v-else class="txt" :style="{ color: headerStyle.toolbarTitleColor }">
                <span @click="nativeOpenLink" v-html="parseTextFromContent(chat.content, chat.senderType, chat.messageType)"></span>
              </div>
            </div>
          </div>
        </div>
        <!-- // UserMsg -->
        <!-- chatMsg !(chat.messageType === 'END' && chat.channelName === 'SCENARIO') -->
        <div
          v-else-if="
            chat.messageType !== 'BROWSER_EXIT' &&
            chat.messageType !== 'TAKE_OVER' &&
            chat.messageType !== 'AUTO_CLOSE' &&
            chat.messageType !== 'BAN_WORD' &&
            chat.messageType !== 'FAQ' &&
            !JSON.parse(chat.content).isHidden
          "
          class="systemBox"
        >
          <div class="name" :class="{ systemIcon: chat.messageType === 'SCENARIO' }">
            <div v-if="$isSeller">
              {{ headerStyle.toolbarAgentName || '상담사' }}
            </div>
            <div v-else>
              <img :src="checkImage(chat)" />
              {{ headerStyle.toolbarAgentName || '상담사' }}
            </div>
          </div>
          <div class="balloonBox">
            <div
              class="msgBg"
              :class="{
                dimmed: $parent.isEnd && chat.messageType !== 'SURVEY'
              }"
              :style="{ width: hasChatButtons(chat.content) ? '100%' : 'auto' }"
            >
              <div v-if="chat.messageType === 'COMBINATION' || chat.messageType === 'SURVEY'" class="TEXT">
                <!-- 헥토이노베이션 커스텀 start -->
                <p class="title" v-if="isHectoBrand">{{ getCustomCombinationTitle(chat.content) }}</p>
                <!-- 헥토이노베이션 커스텀 end -->
                <p class="txt" :style="{ paddingTop: chat.buttons ? '5px' : '0' }" v-html="parseTextFromContent(chat.content, chat.senderType)"></p>
                <div class="btns" v-if="hasChatButtons(chat.content)">
                  <ButtonContents
                    :messageType="chat.messageType"
                    :chatIndex="chatIndex"
                    :scenarioData="scenarioData"
                    :clickedCategory="clickedCategory"
                    :chatButtons="JSON.parse(chat.content).buttons"
                    :chat="chat"
                  />
                </div>
              </div>
              <ImageList v-else-if="chat.messageType === 'PHOTO'" :content="chat.content" @imgLoaded="imgLoaded"></ImageList>
              <!--  챗봇  -->
              <div v-else-if="chat.messageType === 'SCENARIO'">
                <ScenarioList
                  :chatIndex="chatIndex"
                  :chat="chat"
                  :clickedCategory="clickedCategory"
                  :scenarioData="scenarioData"
                  :isBubble="isUseBubble"
                />
              </div>
              <div v-else class="TEXT">
                <span class="txt" v-html="parseTextFromContent(chat.content, chat.senderType)" @click="nativeOpenLink"></span>
              </div>
            </div>
            <span class="time">{{ printCreateMessageDateTime(chat.createDate) }}</span>
          </div>
          <!-- 한살림 챗봇 커스텀 버블 버튼 -->
          <div v-if="chat.messageType === 'SCENARIO' && isUseBubble">
            <div v-if="JSON.parse(chat.content).buttons">
              <BubbleButtonContents
                :messageType="messageType"
                :chatIndex="chatIndex"
                :scenarioData="scenarioData"
                :clickedCategory="clickedCategory"
                :chatButtons="JSON.parse(chat.content).buttons"
                :chat="chat"
              />
            </div>
            <div v-show="hasCounselorButton(JSON.parse(chat.content).buttons).length > 0">
              <BubbleCounselorButtons
                :counselorButtons="JSON.parse(chat.content).buttons"
                :messageType="messageType"
                :clickedCategory="clickedCategory"
                :chat="chat"
              />
            </div>
          </div>
        </div>
        <!-- // chatMsg -->
        <!--            <div v-if="chat.messageType === 'BROWSER_EXIT'" class="msgLine">-->
        <!--                <div class="box"><span :class="{ botIcon: chat.channelName ==='SCENARIO', chatIcon: chat.channelName === 'WEB_CHAT' }" v-html="parseTextFromContent(chat.content, chat.senderType)"></span></div>-->
        <!--            </div>-->
        <div v-if="chat.messageType === 'END' && chat.channelName === 'SCENARIO'" class="msgLine">
          <div class="box"><span class="botIcon">챗봇 상담이 종료되었습니다.</span></div>
        </div>
        <div v-if="chat.messageType === 'END' && chat.channelName === 'WEB_CHAT'" class="msgLine">
          <div class="box"><span class="chatIcon">웹챗 상담이 종료되었습니다.</span></div>
        </div>
        <div v-if="chat.messageType === 'AUTO_CLOSE'" class="msgLine autoCloseText">
          <p class="time">{{ printCreateMessageDateTime(chat.createDate) }}</p>
          <div class="box" v-html="parseTextFromContent(chat.content, chat.senderType)"></div>
        </div>
        <div v-if="chat.messageType === 'BAN_WORD'" class="msgLine">
          <div class="box">
            <span class="banWordIcon"><i class="UXicon-warning"></i>{{ parseTextFromContent(chat.content, chat.senderType) }}</span>
          </div>
        </div>
        <!-- 커스텀 검색 기능 -->
        <div
          v-if="!$isSeller && chat.senderType !== 'USER' && chat.messageType === 'FAQ'"
          class="systemBox"
          :class="isSearchButton && 'searchMargin'"
        >
          <div class="name" :class="{ systemIcon: chat.messageType === 'SCENARIO' }" v-if="!isSearchButton(chat)">
            <div>
              <img :src="checkImage(chat)" />
              {{ headerStyle.toolbarAgentName || '상담사' }}
            </div>
          </div>
          <div class="balloonBox">
            <div class="msgBg" :class="{ dimmed: $parent.isChatBotEnd }" style="width: 100%">
              <FaqList
                :senderUid="uuid"
                :chatRoomId="chatRoomId"
                :chatIndex="chatIndex"
                :chat="chat"
                :scenarioData="scenarioData"
                :clickedCategory="clickedCategory"
                @setFaq="setFaq"
              />
            </div>
            <span class="time">{{ printCreateMessageDateTime(chat.createDate) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from '@/util/helpers';
import messageUtil from '@/util/messages';
import ScenarioList from './ScenarioList';
import ButtonContents from './ButtonContents';
import FaqList from './FaqList';
import Autolinker from 'autolinker';
import { mapGetters } from 'vuex';
import { searchLayoutHelper } from '@/components/mixin/custom/search';
import ImageList from './ImageList';
import BubbleButtonContents from './notice/custom/hansalim/BubbleButtonContents';
import BubbleCounselorButtons from './notice/custom/hansalim/BubbleCounselorButtons';

export default {
  name: 'MsgList',
  components: {
    ScenarioList,
    ButtonContents,
    FaqList,
    ImageList,
    BubbleButtonContents,
    BubbleCounselorButtons
  },
  mixins: [searchLayoutHelper],
  computed: {
    ...mapGetters(['chatRoomData'])
  },
  props: {
    messages: Array,
    chatRoomId: Number,
    setFaq: Function,
    isNotAvailable: Function,
    isUseBubble: Boolean
  },
  data() {
    return {
      headerStyle: {},
      loading: false,
      chatButtons: [],
      uuid: window.localStorage.getItem(process.env.VUE_APP_LOGIN_ID)
        ? window.localStorage.getItem(process.env.VUE_APP_LOGIN_ID)
        : window.localStorage.getItem(process.env.VUE_APP_UUID_KEY),
      scenarioContent: {},
      scenarioData: {},
      brandQuery: window.sessionStorage.getItem('BRAND_QUERY') ? JSON.parse(window.sessionStorage.getItem('BRAND_QUERY')) : undefined,
      windowPopup: null,
      isHectoBrand: false,
      messageType: 'SCENARIO'
    };
  },
  updated() {
    if (this.messages && (this.messages.length > 1 || this.messages[0].messageType !== 'SCENARIO')) {
      setTimeout(() => {
        const container = this.$parent.$refs.scrollList.$el;
        container.scrollTop = container.scrollHeight;
      }, 50);
    }
  },
  mounted() {
    this.headerStyle = this.chatRoomData.headerStyle;
    const scenarioDataItem = window.sessionStorage.getItem('SCENARIO_CHECK_DATA');
    this.scenarioData = scenarioDataItem ? JSON.parse(scenarioDataItem) : {};
    this.$mitt.on('openWindow', (url) => {
      try {
        if (navigator.userAgent.indexOf(this.brandQuery.appId) > -1) {
          const parameters = {
            func: 'onExternalPage',
            url: url
          };
          if (navigator.userAgent.indexOf('Android') > -1) {
            window.AppJSInterface.onExternalPage(JSON.stringify(parameters));
          } else {
            window.webkit.messageHandlers.AppJSInterface.postMessage(parameters);
          }
        } else {
          this.windowPopup.location.href = url;
        }
      } catch (e) {
        console.log(e);
      }
    });
  },
  methods: {
    getVideoFromContent(content) {
      const jsonContent = JSON.parse(content);
      return jsonContent.url;
    },
    videoClick(url) {
      this.$mitt.emit('windowOpen', {
        url: process.env.VUE_APP_WEBCHAT_URL + '/video/chat/open?videoUrl=' + url,
        target: '_blank',
        features: 'location=1,status=1,toolbar=1,scrollbars=1,resizeable=1,width=800,height=800'
      });
    },
    imgLoaded() {
      const container = this.$parent.$refs.scrollList.$el;
      container.scrollTop = container.scrollHeight;
    },
    printCreateMessageDateTime(datetimeString) {
      return helpers.printTimeStampMessageFromDateTime(datetimeString);
    },
    nativeOpenLink(e) {
      if (e.target.matches('.nativeBtn')) {
        let http = e.target.innerText.indexOf('http') !== -1 ? '' : 'http://';
        this.$mitt.emit('windowOpen', {
          url: http + e.target.innerText,
          target: '',
          features: ''
        });
      }
    },
    parseTextFromContent(content, type, messageType) {
      const jsonContent = JSON.parse(content);
      if (messageType && messageType === 'END') {
        jsonContent.text = jsonContent.text.split('<br>').join('\n');
      }
      const parseContent = type === 'SYSTEM' ? jsonContent.text : messageUtil.xssCheck(jsonContent.text);
      if (jsonContent.code === undefined) {
        jsonContent.text = Autolinker.link(parseContent, {
          stripPrefix: false,
          replaceFn(match) {
            if (match.getType() === 'url') {
              if (
                /android/i.test(navigator.userAgent) ||
                /iPhone|iPad/i.test(navigator.platform) ||
                window.navigator.userAgent.toUpperCase().indexOf('KAKAO') > -1
              ) {
                return `<a class="nativeBtn" href="${match.url}" target="_blank">${match.matchedText}</a>`;
              } else {
                return true;
              }
            }
            if (match.getType() === 'phone') {
              return `<a href="tel:${match.number}">${match.matchedText}</a>`;
            }
          }
        });
      }
      return jsonContent.text;
    },
    hasChatButtons(content) {
      const jsonContent = JSON.parse(content);
      return !!(jsonContent.buttons && jsonContent.buttons.length > 0);
    },
    clickedCategory(item, type, index, chat) {
      if (type && type !== 'HOLD' && chat && chat.senderType && chat.senderType !== 'USER') {
        if (type === 'FAQ' && !this.$isSeller) {
          if (this.$parent.isChatBotEnd) {
            return false;
          }
        }

        if (['START', 'CONNECT'].indexOf(type) === -1 && !(type === 'SCENARIO' && this.isUseBubble)) {
          if (['BROWSER_EXIT', 'TAKE_OVER', 'AUTO_CLOSE', 'BAN_WORD', 'FAQ'].indexOf(type) === -1 && !JSON.parse(chat.content).isHidden) {
            if (type !== 'SURVEY' && this.$parent.isEnd) {
              return false;
            }
          }
        }
      }

      if (this.chatRoomId === undefined) {
        return;
      }
      if (item.type === 'URL') {
        if (item.data === '이용 약관 보기') {
          this.$mitt.emit('windowOpen', {
            url: item.code,
            target: 'urlWindow',
            features: 'toolbar=no,menubar=no,resizeable=1,width=400,height=300'
          });
          return;
        } else {
          this.$mitt.emit('windowOpen', {
            url: item.pcUrl || item.mobileUrl,
            target: 'urlWindow',
            features: 'height=' + screen.height + ',width=' + screen.width + 'fullscreen=yes'
          });
          return;
        }
      } else if (item.type === 'CUSTOM_URL') {
        if (item.data === '이용 약관 보기') {
          this.$mitt.emit('windowOpen', {
            url: item.pcUrl || item.mobileUrl,
            target: 'urlWindow',
            features: 'toolbar=no,menubar=no,resizeable=1,width=400,height=300'
          });
          return;
        }
      }
      let content = {};

      if (type === 'COMBINATION') {
        content = { text: item.data, code: item.code };
      } else {
        content = { code: item.code, text: item.text };
      }
      if (type === 'SCENARIO' || type === 'COMBINATION') {
        this.scenarioData[index] = item.code;
        window.sessionStorage.setItem('SCENARIO_CHECK_DATA', JSON.stringify(this.scenarioData));
      }

      this.loading = true;
      if (item.channelName === 'NAVER_TALK' || item.channelName === 'KAKAO_TALK' || item.channelName === 'FACEBOOK_TALK') {
        if (navigator.userAgent.indexOf(this.brandQuery.appId) === -1) {
          this.windowPopup = window.open('about:blank', '_blank');
        }
      }
      this.$http({
        method: 'POST',
        url: '/api/external/webchat/sendMessage',
        data: {
          senderUid: this.uuid,
          chatRoomId: this.chatRoomId,
          messageType: type,
          scenarioTemplateCode: type === 'COMBINATION' ? '' : item.code,
          content: JSON.stringify(content)
        }
      })
        .then((res) => {
          if (res.data.code !== 0) {
            if (this.isNotAvailable(res.data)) return;
            this.$mitt.emit('DialogPopup', {
              useDialog: true,
              message: '<dl class="txt"><dd>' + res.data.message + '</dd></dl>'
            });
          }
        })
        .catch((errorMsg) => {
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>' + errorMsg + '</dd></dl>'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    checkImage(chat) {
      if (chat.messageType === 'SCENARIO' || chat.messageType === 'FAQ') {
        return this.headerStyle.toolbarAgentIconPath
          ? this.headerStyle.toolbarAgentIconPath
          : 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_chatbot_v2.png';
      } else {
        return (
          (this.headerStyle && this.headerStyle.toolbarAgentIconPath) ||
          'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_webchat_v2.png'
        );
      }
    },
    getCustomCombinationTitle(content) {
      // 헥토이노베이션 커스텀 (override해서 사용)
      return null;
    },
    hasCounselorButton(buttons) {
      return buttons ? buttons.filter((b) => b.type === 'COUNSELOR_BUTTON') : 0;
    }
  }
};
</script>
